import React, { createContext, useContext, useState, useCallback } from "react";

const ContactDialogContext = createContext({
  open: false,
  intent: null, // 'demo' | 'pricing' | null
  openDialog: () => {},
  closeDialog: () => {},
});

export const ContactDialogProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [intent, setIntent] = useState(null);

  const openDialog = useCallback((nextIntent = null) => {
    setIntent(nextIntent);
    setOpen(true);
  }, []);

  const closeDialog = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <ContactDialogContext.Provider value={{ open, intent, openDialog, closeDialog, setOpen }}>
      {children}
    </ContactDialogContext.Provider>
  );
};

export const useContactDialog = () => useContext(ContactDialogContext);
